import { render, staticRenderFns } from "./ItemBonos.vue?vue&type=template&id=1d323284&"
import script from "./ItemBonos.vue?vue&type=script&lang=js&"
export * from "./ItemBonos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports